import React, { useRef, useState, useEffect } from "react";
import styles from "./FAQ.module.css";

const FAQ = () => {
  const faqData = [
    {
      category: "Strony internetowe",
      questions: [
        {
          question: "Jak długo trwa realizacja projektu?",
          answer:
            "Czas realizacji zależy od skomplikowania projektu oraz elementów, które zostaną zlecone dodatkowo na Państwa życzenie. Jednakże, zazwyczaj czas oczekiwania wynosi od 2 do 4 tygodni."
        },
        {
          question: "Czy oferujecie wsparcie po uruchomieniu strony?",
          answer:
            "Tak. Po wdrożeniu strony nadal zapewniamy wsparcie techniczne. Wprowadzamy aktualizacje, poprawki oraz rozbudowę strony zgodnie z Państwa potrzebami – w ramach abonamentu opieki technicznej lub jako jednorazową, dodatkowo płatną usługę."
        },
        {
          question: "Czy mogę samodzielnie aktualizować treści na stronie?",
          answer:
            "Nie. Tworzone przez nas strony nie posiadają panelu administracyjnego do samodzielnej edycji treści. Dzięki temu są w pełni dopasowane do potrzeb klienta, a wszelkie zmiany wykonujemy na zlecenie, dbając o ich poprawne wdrożenie."
        },
        {
          question: "Czy pomagacie w wyborze hostingu i domeny?",
          answer:
            "Tak. Służymy pomocą przy wyborze hostingu i domeny oraz możemy przejąć cały proces ich rejestracji i konfiguracji. Dzięki temu nie muszą się Państwo martwić kwestiami technicznymi. Należy jednak pamiętać, że koszty hostingu, domeny (oraz ewentualnie płatnego certyfikatu SSL) ponosi klient. Opłaty te nie są wliczone w cenę naszych pakietów."
        },
        {
          question:
            "Jakich informacji będziecie potrzebować ode mnie na początku współpracy?",
          answer:
            "Na początku współpracy będziemy potrzebować kilku podstawowych informacji o Państwa firmie, ofercie oraz celu, jaki ma spełniać strona internetowa. Przydadzą się również materiały, takie jak logo, teksty, zdjęcia czy dane kontaktowe, a także informacje o preferowanym wyglądzie strony. Jeśli nie posiadają Państwo wszystkich materiałów, wspólnie ustalimy najlepsze rozwiązanie."
        },
        {
          question:
            "Czy mogę zamówić konsultację dotyczącą strony WWW w mojej siedzibie firmy?",
          answer:
            "Tak. Istnieje możliwość realizacji stacjonarnych konsultacji dotyczących stron internetowych również w siedzibie klienta lub innym wskazanym miejscu. Jeżeli miejsce realizacji usługi znajduje się poza obszarem, w którym standardowo świadczymy nasze usługi, do ceny konsultacji mogą zostać doliczone dodatkowe koszty związane z dojazdem. Koszt realizacji usługi poza naszym standardowym obszarem działania może zależeć m.in. od odległości od naszej siedziby oraz czasu potrzebnego na dojazd. Szczegóły i indywidualną wycenę ustalamy przed rozpoczęciem współpracy."
        }
      ]
    },
    {
      category: "Szkolenia",
      questions: [
        {
          question: "W jakiej formie odbywają się szkolenia?",
          answer:
            "Szkolenia realizujemy przede wszystkim w formie stacjonarnej, jednak wybrane tematy możemy przeprowadzić również online. Formę szkolenia dopasowujemy do jego zakresu oraz indywidualnych potrzeb uczestników, tak aby nauka była jak najbardziej komfortowa i efektywna."
        },
        {
          question: "Jak długo trwa szkolenie?",
          answer:
            "Długość szkolenia zależyod jego tematyki, zakresu materiału poziomu zaawansowania uczestników oraz potrzeb uczestników. Każde szkolenie ma indywidualnie określony zakres i czas trwania, a szczegółowe informacje znajdują się w opisie konkretnego szkolenia."
        },
        {
          question:
            "Czy mogę zamówić szkolenie stacjonarne, jeśli mieszkam poza miastem, w którym realizowane są szkolenia?",
          answer:
            "Tak. Istnieje możliwość organizacji szkoleń stacjonarnych również poza miejscem, w którym standardowo prowadzimy zajęcia. W takim przypadku szkolenie może być realizowane w bardziej intensywnym trybie, np. poprzez połączenie większej liczby godzin zajęć w krótszym okresie. Ze względu na dodatkowe koszty organizacyjne związane z realizacją szkolenia poza naszą standardową lokalizacją (m.in. dojazd, wynajem sali szkoleniowej, a w przypadku dłuższych szkoleń również zakwaterowanie), przygotowujemy indywidualną wycenę usługi. Szczegóły ustalamy przed rozpoczęciem szkolenia."
        },
        {
          question: "Czy po ukończeniu szkolenia otrzymam certyfikat?",
          answer:
            "Tak, po ukończeniu szkolenia uczestnicy otrzymują certyfikat lub zaświadczenie potwierdzające udział w szkoleniu i zdobyte umiejętności."
        },
        {
          question: "Jaki jest poziom zaawansowania szkoleń?",
          answer:
            "Oferujemy szkolenia na różnych poziomach zaawansowania – od podstawowego po bardziej zaawansowany. W opisie każdego szkolenia znajdują się informacje dotyczące wymaganego poziomu wiedzy oraz umiejętności."
        },
        {
          question: "Czy zapewniacie sprzęt do nauki?",
          answer:
            "Tak. W razie potrzeby zapewniamy uczestnikom niezbędny sprzęt komputerowy. Zachęcamy jednak, aby w miarę możliwości korzystać z własnego laptopa lub komputera. Dzięki temu uczestnicy uczą się na urządzeniu, z którego korzystają na co dzień, co ułatwia utrwalenie zdobytych umiejętności i późniejsze samodzielne korzystanie z poznanych narzędzi."
        },
        {
          question: "Czy szkolenia są prowadzone w małych grupach?",
          answer:
            "Tak. Stawiamy na kameralną formę zajęć. Szkolenia prowadzimy indywidualnie lub w małych grupach, dzięki czemu możemy poświęcić każdemu uczestnikowi więcej uwagi, dopasować tempo nauki do jego potrzeb oraz zapewnić komfortowe warunki do zdobywania nowych umiejętności."
        },
        {
          question: "Jak zapisać się na szkolenie?",
          // answer:
          //   "Na szkolenie można zapisać się poprzez formularz kontaktowy dostępny na naszej stronie, telefonicznie lub mailowo. W przypadku kontaktu mailowego poza formularzem prosimy o podanie numeru telefonu, abyśmy mogli sprawniej skontaktować się z Państwem i ustalić szczegóły. Po otrzymaniu zgłoszenia wspólnie ustalimy termin, formę oraz zakres szkolenia."
          answer: (
            <>
              Na szkolenie można zapisać się poprzez{" "}
              <a href="#contact" className={styles.contactInfo}>
                formularz kontaktowy dostępny na naszej stronie, telefonicznie
                lub mailowo.
              </a>{" "}
              W przypadku kontaktu mailowego poza formularzem prosimy o podanie
              numeru telefonu, abyśmy mogli sprawniej skontaktować się z
              Państwem i ustalić szczegóły. Po otrzymaniu zgłoszenia wspólnie
              ustalimy termin, formę oraz zakres szkolenia..
            </>
          )
        },
        {
          question:
            "Czy mogę zgłosić zapotrzebowanie na szkolenie o konkretnej tematyce lub poziomie?",
          answer:
            "Tak. Jeśli w naszej ofercie nie znajduje się szkolenie odpowiadające Państwa potrzebom, zachęcamy do kontaktu. W miarę możliwości przygotowujemy szkolenia dopasowane do indywidualnych oczekiwań uczestników, zarówno pod względem tematyki, jak i poziomu zaawansowania."
        }
      ]
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="sectionContainer light">
      <div className="sectionTitle">
        <h2>FAQ</h2>
      </div>

      <div className={styles.faqContent}>
        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex} className={styles.faqSection}>
            <h3 className={styles.category}>{section.category}</h3>

            {section.questions.map((item, index) => {
              const faqIndex = `${sectionIndex}-${index}`;

              return (
                <div
                  key={faqIndex}
                  className={`${styles.faqItem} ${
                    activeIndex === faqIndex ? styles.active : ""
                  }`}
                >
                  <div
                    className={styles.faqQuestion}
                    onClick={() => toggleFAQ(faqIndex)}
                  >
                    {item.question}
                  </div>

                  <div className={styles.faqAnswer}>{item.answer}</div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
